import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { userTaxOptOutReasonsBackend } from './user-tax-opt-out-reasons.backend';
import { userTaxOptOutReasonsReducer } from './user-tax-opt-out-reasons.reducer';

@NgModule({
  imports: [
    BackendModule.forFeature(
      'userTaxOptOutReasons',
      userTaxOptOutReasonsBackend,
    ),
    StoreModule.forFeature('userTaxOptOutReasons', userTaxOptOutReasonsReducer),
  ],
})
export class DatastoreUserTaxOptOutReasonsModule {}
